import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Breadcrumbs, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface DeviceHeaderProps {
  deviceId: string;
}

export const DeviceHeader: React.FC<DeviceHeaderProps> = ({ deviceId }) => {
  const theme = useTheme();

  const breadcrumbs = [
    <Link key="list" to="/devices">
      Devices
    </Link>,
    <Typography
      key="device-id"
      sx={{ fontSize: "1.125rem", fontWeight: "500" }}
      color="text.secondary"
    >
      {deviceId}
    </Typography>,
  ];

  return (
    <>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
        sx={{
          fontSize: "1.125rem",
          fontWeight: "500",
          borderBottom: "unset",
          "& a": {
            color: theme.palette.text.secondary,
            textDecoration: "none",
          },
          "& a:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {breadcrumbs}
      </Breadcrumbs>
    </>
  );
};
